// 이메일 인증 확인

import { useLayoutEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAuthEmail } from "./handlers";

export default function JoinAuthEmailPage() {
  const { t } = useTranslation();
  const txtRef = useRef<HTMLHeadingElement | null>(null);

  const { onAuthEmail } = useAuthEmail();

  useLayoutEffect(() => {
    if (txtRef.current) {
      txtRef.current.innerHTML = t("eml_auth_text_1_join");
    }
  }, []);

  return (
    <div className="_inner">
      <h2>{t("eml_auth_join")}</h2>
      <div className="pt-3">
        <h4 className="leading-[28px]" ref={txtRef}></h4>
      </div>
      <div className="flex justify-center pt-[40px]">
        <button
          className="btn text-white bg-red-400 px-2"
          onClick={onAuthEmail}
        >
          {t("btn_eml_auth")}
        </button>
      </div>
    </div>
  );
}
